<template>
  <div>
    <a-descriptions bordered size="small" title="基本信息" :column="3">
      <a-descriptions-item label="设备名称">{{ model.name }}</a-descriptions-item>
      <a-descriptions-item label="是否是虚拟设备">{{ model.sign ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="设备编号">{{ model.equipmentNumber }}</a-descriptions-item>
      <a-descriptions-item label="公司名称">{{ model.subcompanyname }}</a-descriptions-item>
      <a-descriptions-item label="设备状态">{{ model.equipmentStatusName }}</a-descriptions-item>
      <a-descriptions-item label="规格型号">{{ model.specification }}</a-descriptions-item>
      <a-descriptions-item label="设备分类">{{ model.equipmentTypeName }}</a-descriptions-item>
      <a-descriptions-item label="内部编码">{{ model.interiorCode }}</a-descriptions-item>
      <a-descriptions-item label="归口部门">{{ model.relevantdeptname }}</a-descriptions-item>
      <a-descriptions-item label="归口负责人">{{ model.relevantdeptUserName }}</a-descriptions-item>
      <a-descriptions-item label="使用部门">{{ model.usedeptname }}</a-descriptions-item>
      <a-descriptions-item label="使用负责人">{{ model.principalName }}</a-descriptions-item>
      <a-descriptions-item label="资产卡片号">{{ model.assetNumber }}</a-descriptions-item>
      <a-descriptions-item label="设备品牌">{{ model.brand }}</a-descriptions-item>
      <a-descriptions-item label="首次投用日期">{{ model.entryDate }}</a-descriptions-item>
      <a-descriptions-item label="报废日期">{{ model.retirementDate }}</a-descriptions-item>
      <a-descriptions-item label="重要分类">{{ model.importanceType }}</a-descriptions-item>
      <a-descriptions-item label="展示方式">{{ model.displayType === '1' ? '树状展示' : '抽屉展示' }}</a-descriptions-item>
      <a-descriptions-item label="压力容器">{{ model.isYlrqPeculiarity ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="特种设备">{{ model.isTzsbPeculiarity ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="环保特性">{{ model.isHbPeculiarity ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="设施位置/地址">{{ model.address }}</a-descriptions-item>
      <a-descriptions-item label="备注" :span="3">{{ model.remark }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" :column="3" v-for="item in basicTabsList" :title="item.pName">
      <a-descriptions-item :label="item2.name" v-for="item2 in item.children">{{ item2.vaules }}</a-descriptions-item>
      <!--      <a-descriptions-item label="S/N码">{{ model.sn }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="采购类型">{{ model.purchaseType }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="合同编号">{{ model.contractNumber }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="合同名称">{{ model.contractName }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="合同价格">{{ model.contractPrice }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="售后服务类型">{{ model.serviceType }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="维修合同到期">{{ model.maintenanceDate}}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="采购订单编号">{{ model.purchaseOrder }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="供应商名称">{{ model.supplier }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="供应商编号">{{ model.supplierNumber }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="购置价值(万元)">{{ model.kansw }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="购置净值">{{ model.qmzj }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="税率">{{ model.taxRate }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="购置日期">{{ model.purchaseDate}}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="采购人">{{ model.buyer }}</a-descriptions-item>-->
    </a-descriptions>
    <!--    <a-descriptions bordered size="small" title="出厂" :column="3">-->
    <!--      <a-descriptions-item label="生产厂家">{{ model.manufactureFactory }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="生产日期">{{ model.producedDate}}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="出厂日期">{{ model.dateInProduced }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="出厂编号">{{ model.factoryNumber }}</a-descriptions-item>-->
    <!--    </a-descriptions>-->
    <!--    <a-descriptions bordered size="small" title="项目及SAP信息" :column="3">-->
    <!--      <a-descriptions-item label="项目编号">{{ model.projectNumber }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="WBS编号">{{ model.wbsNumber }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="SAP编号">{{ model.sapNumber }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="SAP分类">{{ model.sapTypeName }}</a-descriptions-item>-->
    <!--    </a-descriptions>-->
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    model: Object,
    basicTabsList: Array
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {
        xxx: 'xxxxxx'
      }
    }
  },
  methods: {
    initDetail (model) {
      this.model.dateInProduced = model.dateInProduced ? moment(model.dateInProduced).format('YYYY-MM-DD') : ''
      this.model.arrivalDate = model.arrivalDate ? moment(model.arrivalDate).format('YYYY-MM-DD') : ''
      this.model.purchaseDate = model.purchaseDate ? moment(model.purchaseDate).format('YYYY-MM-DD') : ''
      this.model.deloveryDate = model.deloveryDate ? moment(model.deloveryDate).format('YYYY-MM-DD') : ''
      this.model.producedDate = model.producedDate ? moment(model.producedDate).format('YYYY-MM-DD') : ''
      this.model.outboundDeliveryDate = model.outboundDeliveryDate ? moment(model.outboundDeliveryDate).format('YYYY-MM-DD') : ''
      this.model.dateOfDelivery = model.dateOfDelivery ? moment(model.dateOfDelivery).format('YYYY-MM-DD') : ''
      this.model.retirementDate = model.retirementDate ? moment(model.retirementDate).format('YYYY-MM-DD') : ''
      this.model.capitalizationDate = model.capitalizationDate ? moment(model.capitalizationDate).format('YYYY-MM-DD') : ''
      this.model.entryDate = model.entryDate ? moment(model.entryDate).format('YYYY-MM-DD') : ''
      this.model.maintenanceDate = model.maintenanceDate ? moment(model.maintenanceDate).format('YYYY-MM-DD') : ''
    }
  }
}
</script>

<style scoped>

</style>
